import { FC } from 'react';
import { CardChartAnalytic } from './CardChartAnalytic';
import { CardTableAnalytic } from './CardTableAnalytic';
import { ICardAnalyticItemProps } from './types';

interface CardAnalyticRendererProps {
  item: ICardAnalyticItemProps;
  isLoading: boolean;
  readOnly?: boolean;
  isEnable?: boolean;
  isActive?: boolean;
  hasError?: boolean;
  // Card display variant: 'chart' for chart view, 'table' for table statistics view
  cardVariant?: 'chart' | 'table';
  // Table variant specific props
  filterCount?: number;
  filterValue?: string;
}

export const CardAnalyticRenderer: FC<CardAnalyticRendererProps> = ({
  item,
  isLoading,
  readOnly,
  isEnable,
  isActive,
  hasError,
  cardVariant = 'chart', // Default to chart view
  filterCount,
  filterValue,
}) => {
  // Render Table variant when in table view
  // Table variant is ALWAYS read-only (no card selection)
  if (cardVariant === 'table') {
    return <CardTableAnalytic item={item} isLoading={isLoading} hasError={hasError} filterCount={filterCount} filterValue={filterValue} />;
  }

  // Default: Render Chart variant
  return <CardChartAnalytic item={item} isLoading={isLoading} readOnly={readOnly} isEnable={isEnable} isActive={isActive} hasError={hasError} />;
};
